// Function to encrypt a message using a Caesar cipher
export function encryptText(message, shift) {
    shift = (shift % 26 + 26) % 26;

    return message?.split('').map(char => {
        if (char.match(/[a-zA-Z]/)) {
            const code = char.charCodeAt(0);
            const offset = char.toUpperCase() === char ? 65 : 97;
            return String.fromCharCode((code - offset + shift) % 26 + offset);
        } else {
            return char;
        }
    }).join('');
}

// Function to decrypt a message using a Caesar cipher
export function decryptText(message, shift) {
    // Decryption is the same as encryption with a negative shift
    return encryptText(message, -shift);
}
